module.exports = __webpack_public_path__ + "img/menu-bg0.9a8364da.png";